export const emailValidationRegExps = {
  forgiving: /^[^\s@]+@[^\s@]+\.[^\s@]+$/im, // accepts any '*@*.*' email format
};
